import _ from 'lodash';

/** A typesafe invert for Records */
export function invert<T1 extends string, T2 extends string>(
  map: Record<T1, T2>,
): Record<T2, T1> {
  return _.invert(map) as Record<T2, T1>;
}
